/**
 * Mağaza Durumu özet satırları (magazadurumu.js KPI mantığı).
 */
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  Timestamp,
  where,
} from 'firebase/firestore';
import { db } from '../firebase';
import { formatMoneyTr, formatQtyTr } from './gunsonuWhatsappReport';

const MAGAZA_CATEGORIES = [
  {
    key: 'sarrafiye',
    name: 'Sarrafiye',
    field: 'adet',
    urunler: [
      { key: 'eskiZiynetCeyrek', hasCarpan: 1.61 },
      { key: 'yeniZiynetCeyrek', hasCarpan: 1.62 },
      { key: 'eskiZiynetYarim', hasCarpan: 3.22 },
      { key: 'yeniZiynetYarim', hasCarpan: 3.24 },
      { key: 'eskiZiynetTam', hasCarpan: 6.44 },
      { key: 'yeniZiynetTam', hasCarpan: 6.48 },
      { key: 'eskiZiynetGremse', hasCarpan: 16.1 },
      { key: 'yeniZiynetGremse', hasCarpan: 16.2 },
      { key: 'eskiZiynetBesli', hasCarpan: 32.2 },
      { key: 'yeniZiynetBesli', hasCarpan: 32.4 },
      { key: 'cumhuriyetAtaCeyrek', hasCarpan: 1.68 },
      { key: 'cumhuriyetAtaYarim', hasCarpan: 3.36 },
      { key: 'cumhuriyetAta', hasCarpan: 6.7 },
      { key: 'cumhuriyetAtaGremse', hasCarpan: 16.75 },
      { key: 'cumhuriyetAtaBesli', hasCarpan: 33.5 },
      { key: 'resatCeyrek', hasCarpan: 1.75 },
      { key: 'resatYarim', hasCarpan: 3.5 },
      { key: 'resat', hasCarpan: 7 },
      { key: 'resatGremse', hasCarpan: 17.5 },
      { key: 'resatBesli', hasCarpan: 35 },
    ],
  },
  {
    key: 'gramAltin',
    name: 'Gram Altın',
    field: 'adet',
    urunler: [
      { key: 'birGram22Ayar', hasCarpan: 0.912 },
      { key: 'yariGram22Ayar', hasCarpan: 0.456 },
      { key: 'ceyrekGram22Ayar', hasCarpan: 0.228 },
      { key: 'birGram24Ayar', hasCarpan: 0.995 },
      { key: 'yariGram24Ayar', hasCarpan: 0.498 },
      { key: 'ceyrekGram24Ayar', hasCarpan: 0.249 },
      { key: 'ikiBucukGram24Ayar', hasCarpan: 2.49 },
      { key: 'besGram24Ayar', hasCarpan: 4.98 },
      { key: 'onGram24Ayar', hasCarpan: 9.95 },
      { key: 'yirmiGram24Ayar', hasCarpan: 19.9 },
      { key: 'elliGram24Ayar', hasCarpan: 49.75 },
      { key: 'yuzGram24Ayar', hasCarpan: 99.5 },
    ],
  },
  {
    key: 'hurda',
    name: 'Hurda',
    field: 'gram',
    urunler: [
      { key: 'yirmiDortAyarHurda', hasCarpan: 0.995 },
      { key: 'yirmiIkiAyarBilezikHurda', hasCarpan: 0.912 },
      { key: 'yirmiIkiAyarHurda', hasCarpan: 0.91 },
      { key: 'yirmiBirAyarHurda', hasCarpan: 0.85 },
      { key: 'onSekizAyarHurda', hasCarpan: 0.72 },
      { key: 'onDortAyarHurda', hasCarpan: 0.575 },
      { key: 'sekizAyarHurda', hasCarpan: 0.31 },
    ],
  },
  {
    key: 'takiUrun',
    name: 'Takı Ürün',
    field: 'gram',
    urunler: [
      { key: 'yirmiIkiAyarBilezik', label: '22 Ayar Bilezik', hasCarpan: 0.912 },
      { key: 'onDortAyarBilezik', label: '14 Ayar Bilezik', hasCarpan: 0.575 },
      { key: 'sekizAyarBilezik', label: '8 Ayar Bilezik', hasCarpan: 0.32 },
      { key: 'yirmiIkiAyarTaki', label: '22 Ayar Takı', hasCarpan: 0.912 },
      { key: 'yirmiBirAyarTaki', label: '21 Ayar Takı', hasCarpan: 0.86 },
      { key: 'onSekizAyarTaki', label: '18 Ayar Takı', hasCarpan: 0.73 },
      { key: 'onDortAyarTaki', label: '14 Ayar Takı', hasCarpan: 0.575 },
      { key: 'sekizAyarTaki', label: '8 Ayar Takı', hasCarpan: 0.32 },
    ],
  },
  {
    key: 'doviz',
    name: 'Döviz',
    field: 'adet',
    urunler: [
      { key: 'tl', currencyCode: 'TLTRY', hasCarpan: 1 },
      { key: 'usd', currencyCode: 'USDTRY', hasCarpan: 0 },
      { key: 'eur', currencyCode: 'EURTRY', hasCarpan: 0 },
      { key: 'gbp', currencyCode: 'GBPTRY', hasCarpan: 0 },
      { key: 'chf', currencyCode: 'CHFTRY', hasCarpan: 0 },
      { key: 'aud', currencyCode: 'AUDTRY', hasCarpan: 0 },
      { key: 'cad', currencyCode: 'CADTRY', hasCarpan: 0 },
      { key: 'sar', currencyCode: 'SARTRY', hasCarpan: 0 },
      { key: 'aed', currencyCode: 'AEDTRY', hasCarpan: 0 },
      { key: 'qar', currencyCode: 'QARTRY', hasCarpan: 0 },
      { key: 'mad', currencyCode: 'MADTRY', hasCarpan: 0 },
      { key: 'jod', currencyCode: 'JODTRY', hasCarpan: 0 },
      { key: 'kwd', currencyCode: 'KWDTRY', hasCarpan: 0 },
      { key: 'cny', currencyCode: 'CNYTRY', hasCarpan: 0 },
      { key: 'rub', currencyCode: 'RUBTRY', hasCarpan: 0 },
      { key: 'bgn', currencyCode: 'BGNTRY', hasCarpan: 0 },
    ],
  },
  {
    key: 'genel',
    name: 'Genel',
    field: 'gram',
    urunler: [{ key: 'gumus', currencyCode: 'GUMUSTRY', hasCarpan: 0 }],
  },
];

function normalizeString(str) {
  return str ? str.trim().toLocaleLowerCase('tr-TR').replace(/\s+/g, ' ') : '';
}

function resolveAltinTryBuy(prices) {
  const list = prices || [];
  const altin = list.find((p) => p.currencyCode === 'ALTINTRY');
  let buy = Number(altin?.buy) || 0;
  if (buy > 0) return buy;
  const xau = list.find((p) => p.currencyCode === 'XAUUSD');
  const usd = list.find((p) => p.currencyCode === 'USDTRY');
  if (xau?.buy && usd?.buy) return Number(xau.buy) * Number(usd.buy);
  return 0;
}

function categoryTotalHas(kasaData, categoryKey, prices, altinTryBuy) {
  const cat = MAGAZA_CATEGORIES.find((c) => c.key === categoryKey);
  if (!cat || !kasaData?.[categoryKey]) return 0;
  let total = 0;

  if ((categoryKey === 'doviz' || categoryKey === 'genel') && altinTryBuy > 0) {
    cat.urunler.forEach((item) => {
      const miktar =
        cat.field === 'adet'
          ? kasaData[categoryKey]?.[item.key]?.adet || 0
          : kasaData[categoryKey]?.[item.key]?.gram || 0;
      if (!miktar) return;
      let tlDegeri = 0;
      if (item.currencyCode === 'TLTRY') tlDegeri = miktar;
      else {
        const kur = prices.find((p) => p.currencyCode === item.currencyCode)?.buy || 0;
        tlDegeri = miktar * kur;
      }
      total += tlDegeri / altinTryBuy;
    });
  } else {
    cat.urunler.forEach((item) => {
      const val =
        cat.field === 'adet'
          ? kasaData[categoryKey][item.key]?.adet || 0
          : kasaData[categoryKey][item.key]?.gram || 0;
      total += val * (item.hasCarpan || 0);
    });
  }
  return parseFloat(total.toFixed(2));
}

/** Magaza durumu stok ağacı (sayfa mantığı — sadeleştirilmiş). */
async function fetchMagazaKasaTree(sube) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const gunsonuQuery = query(
    collection(db, 'subeler', sube, 'gunsonukasa'),
    where('timestamp', '<', Timestamp.fromDate(today)),
    orderBy('timestamp', 'desc'),
    limit(1)
  );
  const gunsonuSnapshot = await getDocs(gunsonuQuery);
  const dunkuKapanis = !gunsonuSnapshot.empty ? gunsonuSnapshot.docs[0].data() : {};
  const lastTimestamp = dunkuKapanis.timestamp || new Timestamp(0, 0);

  const islemQuery = query(
    collection(db, 'subeler', sube, 'islemler'),
    orderBy('timestamp', 'asc')
  );
  const snapshot = await getDocs(islemQuery);
  const islemler = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));

  const labelByKey = {
    eskiZiynetCeyrek: 'Eski Ziynet Çeyrek',
    yeniZiynetCeyrek: 'Yeni Ziynet Çeyrek',
    eskiZiynetYarim: 'Eski Ziynet Yarım',
    yeniZiynetYarim: 'Yeni Ziynet Yarım',
    eskiZiynetTam: 'Eski Ziynet Tam',
    yeniZiynetTam: 'Yeni Ziynet Tam',
    eskiZiynetGremse: "Eski Ziynet 2.5'lu Gremse",
    yeniZiynetGremse: "Yeni Ziynet 2.5'lu Gremse",
    eskiZiynetBesli: 'Eski Ziynet Beşli',
    yeniZiynetBesli: 'Yeni Ziynet Beşli',
    cumhuriyetAtaCeyrek: 'Cumhuriyet Ata Çeyrek',
    cumhuriyetAtaYarim: 'Cumhuriyet Ata Yarım',
    cumhuriyetAta: 'Cumhuriyet Ata',
    cumhuriyetAtaGremse: "Cumhuriyet Ata 2.5'lu",
    cumhuriyetAtaBesli: 'Cumhuriyet Ata Beşli',
    resatCeyrek: 'Reşat Çeyrek',
    resatYarim: 'Reşat Yarım',
    resat: 'Reşat',
    resatGremse: "Reşat 2.5'lu",
    resatBesli: 'Reşat Beşli',
    birGram22Ayar: '1 Gram 22 Ayar',
    yariGram22Ayar: '0.50 Gram 22 Ayar',
    ceyrekGram22Ayar: '0.25 Gram 22 Ayar',
    birGram24Ayar: '1 Gram 24 Ayar',
    yariGram24Ayar: '0.50 Gram 24 Ayar',
    ceyrekGram24Ayar: '0.25 Gram 24 Ayar',
    ikiBucukGram24Ayar: '2.50 Gram 24 Ayar',
    besGram24Ayar: '5 Gram 24 Ayar',
    onGram24Ayar: '10 Gram 24 Ayar',
    yirmiGram24Ayar: '20 Gram 24 Ayar',
    elliGram24Ayar: '50 Gram 24 Ayar',
    yuzGram24Ayar: '100 Gram 24 Ayar',
    yirmiDortAyarHurda: '24 Ayar Hurda',
    yirmiIkiAyarBilezikHurda: '22 Ayar Bilezik Hurda',
    yirmiIkiAyarHurda: '22 Ayar Hurda',
    yirmiBirAyarHurda: '21 Ayar Hurda',
    onSekizAyarHurda: '18 Ayar Hurda',
    onDortAyarHurda: '14 Ayar Hurda',
    sekizAyarHurda: '8 Ayar Hurda',
    yirmiIkiAyarBilezik: '22 Ayar Bilezik',
    onDortAyarBilezik: '14 Ayar Bilezik',
    sekizAyarBilezik: '8 Ayar Bilezik',
    yirmiIkiAyarTaki: '22 Ayar Takı',
    yirmiBirAyarTaki: '21 Ayar Takı',
    onSekizAyarTaki: '18 Ayar Takı',
    onDortAyarTaki: '14 Ayar Takı',
    sekizAyarTaki: '8 Ayar Takı',
    tl: 'TL - Türk Lirası',
    usd: 'USD - Amerikan Doları',
    eur: 'EUR - Euro',
    gbp: 'GBP - İngiliz Sterlini',
    chf: 'CHF - İsviçre Frangı',
    aud: 'AUD - Avustralya Doları',
    cad: 'CAD - Kanada Doları',
    sar: 'SAR - Suudi Arabistan Riyali',
    aed: 'AED - Birleşik Arap Emirlikleri Dirhemi',
    qar: 'QAR - Katar Riyali',
    mad: 'MAD - Fas Dirhemi',
    jod: 'JOD - Ürdün Dinarı',
    kwd: 'KWD - Kuveyt Dinarı',
    cny: 'CNY - Çin Yuanı',
    rub: 'RUB - Rus Rublesi',
    bgn: 'BGN - Bulgar Levası',
    gumus: 'Gümüş',
  };

  const kasa = {};
  MAGAZA_CATEGORIES.forEach((cat) => {
    kasa[cat.key] = {};
    cat.urunler.forEach((item) => {
      kasa[cat.key][item.key] = { adet: 0, gram: 0 };
    });
  });

  MAGAZA_CATEGORIES.forEach((cat) => {
    if (cat.key === 'takiUrun' || cat.key === 'genel') return;
    if (!dunkuKapanis[cat.key]) return;
    Object.keys(dunkuKapanis[cat.key]).forEach((key) => {
      if (kasa[cat.key][key] === undefined) return;
      kasa[cat.key][key] = {
        adet: Number(dunkuKapanis[cat.key]?.[key]?.adet || 0),
        gram: Number(dunkuKapanis[cat.key]?.[key]?.gram || 0),
      };
    });
  });

  let bankaBakiyesi = 0;
  let totalDebtGram = 0;

  islemler.forEach((islem) => {
    const havale = parseFloat(islem.havaleEft) || 0;
    if (havale > 0) {
      if (['Satış', 'Giriş'].includes(islem.islemTuru)) bankaBakiyesi += havale;
      else if (['Alış', 'Çıkış', 'İade', 'Değişim'].includes(islem.islemTuru)) bankaBakiyesi -= havale;
    }

    const hasEsdeger = parseFloat(islem.hasEsdeger) || 0;
    if (hasEsdeger > 0 && islem?.firma?.firmaIsmi) {
      if (['Giriş', 'Alış', 'İade', 'Değişim'].includes(islem.islemTuru)) totalDebtGram += hasEsdeger;
      else if (['Çıkış', 'Satış'].includes(islem.islemTuru)) totalDebtGram -= hasEsdeger;
    }

    const islemUrun = normalizeString(islem.urun);
    const islemKategori = normalizeString(islem.kategori);
    const adet = parseInt(islem.adet, 10) || 0;
    const gram = parseFloat(islem.gram) || 0;
    const nakit = parseFloat(islem.nakit) || 0;
    const isTL = islem.kategori === 'Döviz' && islem.urun === 'TL - Türk Lirası';

    MAGAZA_CATEGORIES.forEach((cat) => {
      if (islemKategori !== normalizeString(cat.name)) return;
      const isTakiOrGenel = cat.key === 'takiUrun' || cat.key === 'genel';
      const islemMillis = islem.timestamp?.toMillis ? islem.timestamp.toMillis() : 0;
      const lastMillis = lastTimestamp?.toMillis ? lastTimestamp.toMillis() : 0;
      if (!isTakiOrGenel && islemMillis < lastMillis) return;

      cat.urunler.forEach((item) => {
        const itemLabel = normalizeString(item.label || labelByKey[item.key] || '');
        if (itemLabel !== islemUrun) return;

        const inbound = ['Alış', 'İade', 'Değişim', 'Giriş'].includes(islem.islemTuru);
        const outbound = ['Satış', 'Çıkış'].includes(islem.islemTuru);
        if (!inbound && !outbound) return;
        const sign = inbound ? 1 : -1;

        if (cat.key === 'sarrafiye' || cat.key === 'gramAltin') {
          kasa[cat.key][item.key].adet += sign * adet;
        } else if (cat.key === 'takiUrun') {
          kasa[cat.key][item.key].gram += sign * gram * adet;
        } else if (cat.key === 'hurda' || cat.key === 'genel') {
          kasa[cat.key][item.key].gram += sign * gram;
        } else if (cat.key === 'doviz') {
          kasa[cat.key][item.key].adet += sign * (isTL ? nakit : adet);
        }

        if (!isTakiOrGenel || islemMillis >= lastMillis) {
          if (inbound && nakit > 0 && !isTL && kasa.doviz?.tl) kasa.doviz.tl.adet -= nakit;
          if (outbound && nakit > 0 && !isTL && kasa.doviz?.tl) kasa.doviz.tl.adet += nakit;
        }
      });
    });
  });

  return {
    kasaData: kasa,
    bankaBakiyesi,
    totalDebtGram: parseFloat(totalDebtGram.toFixed(2)),
  };
}

/**
 * @param {string} sube
 * @param {Array<{currencyCode:string,buy:number}>} prices
 * @returns {Promise<Array<{label:string,detail:string}>>}
 */
export async function fetchMagazaDurumuPdfRows(sube, prices = []) {
  const { kasaData, bankaBakiyesi, totalDebtGram } = await fetchMagazaKasaTree(sube);
  const altinTryBuy = resolveAltinTryBuy(prices);

  const rows = MAGAZA_CATEGORIES.map((cat) => {
    const has = categoryTotalHas(kasaData, cat.key, prices, altinTryBuy);
    return {
      label: `${cat.name} Has`,
      detail: `${formatQtyTr(has, 2)} g`,
    };
  });

  const bankaHas = altinTryBuy > 0 ? bankaBakiyesi / altinTryBuy : 0;
  rows.push({
    label: 'Banka',
    detail: `${formatMoneyTr(bankaBakiyesi)} · ${formatQtyTr(bankaHas, 2)} g`,
  });

  const catHasSum = MAGAZA_CATEGORIES.reduce(
    (s, cat) => s + categoryTotalHas(kasaData, cat.key, prices, altinTryBuy),
    0
  );
  const magazaSermaye = parseFloat((catHasSum + bankaHas).toFixed(2));
  const net = parseFloat((magazaSermaye - totalDebtGram).toFixed(2));

  rows.push({ label: 'Mağaza Sermaye', detail: `${formatQtyTr(magazaSermaye, 2)} g` });
  rows.push({ label: 'Firma Borcu', detail: `${formatQtyTr(totalDebtGram, 2)} g` });
  rows.push({ label: 'Net Sermaye', detail: `${formatQtyTr(net, 2)} g` });

  return rows;
}
